import { GetStatementLinesApiParameter } from "@bToC/Services/StatementService";
import StatementDetailsState from "@bToC/Store/Pages/StatementDetails/StatementDetailsState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { Draft } from "immer";

const initialState: StatementDetailsState = {
    getStatementLinesParameter: {
        statementNumber: "",
    },
};

const reducer = {

    "CustomPages/Statements/UpdateLineSearchFields": (
        draft: Draft<StatementDetailsState>,
        action: { parameter: GetStatementLinesApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getStatementLinesParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getStatementLinesParameter = { ...initialState.getStatementLinesParameter, ...action.parameter };
        } else {
            draft.getStatementLinesParameter = { ...draft.getStatementLinesParameter, ...action.parameter };

            for (const key in draft.getStatementLinesParameter) {
                const value = (<any>draft.getStatementLinesParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getStatementLinesParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getStatementLinesParameter.page &&
                    draft.getStatementLinesParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize"
                ) {
                    draft.getStatementLinesParameter.page = 1;
                }
            }
        }
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
